export const CREATE_TEMPLATE_QUERY_PARAM = "create_template"
export const CREATE_TEMPLATE_INTENT_PATH = "/templates/new"
